<template>
    <div>
        <div class="absolute top-0 right-0 z-50 flex flex-col side-menu-z-1000">
            <div class="drawer">
                <input id="my-drawer-4" type="checkbox" class="drawer-toggle" />
                <!-- open drawer button was moved to sidebarnavi--
                <div class="drawer-content">
                    <label for="my-drawer-4" tabindex="0" class="drawer-button btn btn-sm shadow-sm border border-base-content/5 w-10 h-10 side-menu-main">
                        <div class="indicator">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M4 6h16M4 12h16M4 18h7"
                                ></path>
                            </svg>
                        </div>
                    </label>
                </div>
                -->
                <div class="drawer-side">
                    <label for="my-drawer-4" aria-label="close sidebar" class="drawer-overlay"></label>
                    <ul class="menu p-4 pt-2 w-96 min-h-full bg-base-200 text-base-content gap-1">
                        <div class="flex justify-between">
                            <div class=""></div>
                            <div class="btn btn-square btn-sm btn-ghost m-1 close-z-100" @click="toggleDrawer()">
                                <button class="drawer-close-button">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <li :href="displayLink" class="w-full">
                            <a class="w-ttl px-2">
                                <div class="flex items-center">
                                    <!-- commentout logo
                                    <div
                                        class="avatar"
                                        v-if="mapData.logo_url"
                                    >
                                        <div class="w-10 h-10 rounded">
                                            <img :src="mapData.logo_url" />
                                        </div>
                                    </div>
                                    -->
                                    <div
                                        class="flex flex-col items-start text-sm mx-2"
                                        v-if="mapData.title"
                                    >
                                        <div class="text-base-content font-bold break-words text-overflow-wrap w-txt">
                                            {{ mapData.title }}
                                        </div>
                                        <div class="text-base-content/80 font-bold text-xs break-words text-overflow-wrap w-txt">
                                            {{ mapData.sub_title }}
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </li>
                        <div class="divider my-1"></div>
                        <div v-if="parcelTitle" class="my-2 mx-2">
                            <div class="text-base-content font-bold break-words text-overflow-wrap">
                                {{ parcelTitle }}
                            </div>
                            <div class="text-base-content/80 font-bold break-words text-overflow-wrap">
                                {{ layerTitle }}
                            </div>
                            <div class="divider mb-1"></div>
                        </div>
                        <!-- Sidebar content here -->
                        <li v-show="showSwitchLanguage">
                            <details class="dropdown">
                                <summary class="">
                                    <div class="flex items-center">
                                        <span class="material-symbols-outlined pr-0 notranslate fill-current">
                                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Zm0-82q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z"/></svg>
                                        </span>
                                        <span class="ml-2">Language</span>
                                        <div class="ml-2 badge notranslate">{{ trans.locales[currentLocale] }}</div>
                                    </div>
                                </summary>
                                <ul tabindex="0" class="m-0 shadow menu dropdown-content bg-base-100 rounded-box w-full z-10">
                                    <li v-for="locale in locales" :key="'localeKey-' + locale">
                                        <a :href="currentMapLink + '/' + locale + (!categoryId ? '' : '?c=' + categoryId)" class="flex">
                                            <div class="w-18">
                                                <div class="btn-xs btn font-mono font-bold tracking-widest w-14 p-0 opacity-60 notranslate">{{ locale }}</div>
                                            </div>
                                            <div class="notranslate">
                                            {{ trans.locales[locale] }}
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </details>
                        </li>
                        <!--
                        <li v-show="showSwitchLanguage" @click="$emit('toggled', 'localeBox'); toggleDrawer()">
                            <span>
                                <span class="material-symbols-outlined pr-0 notranslate fill-current">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Zm0-82q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z"/></svg>
                                </span>
                                <span>{{ trans.right_menu.language }}</span>
                            </span>
                        </li>
                        -->
                        <!-- refresh btn
                        <li v-show="showRefreshBtn" onClick="window.location.reload()">
                            <a>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="h-6 w-6"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    stroke-width="2"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                    ></path>
                                </svg>
                                <span>{{ trans.right_menu.refresh }}</span>
                            </a>
                        </li>
                        -->
                        <!-- fullscreen
                        <li v-show="showFullscreen">
                            <span>
                                <fullscreen></fullscreen>
                                <span class="pl-0 self-center">{{ trans.right_menu.full_screen }}</span>
                            </span>
                        </li>
                        -->
                        <!-- map setting -->
                        <li @click="$emit('toggled', 'mapSetting'); toggleDrawer()">
                            <a>
                                <span class="material-symbols-outlined notranslate fill-current">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-6 w-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        stroke-width="2"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
                                        ></path>
                                    </svg>
                                </span>
                                <span>{{ trans.right_menu.map_setting }}</span>
                            </a>
                        </li>
                        <li @click="$emit('toggled', 'userGuide'); toggleDrawer()">
                            <a>
                                <span class="material-symbols-outlined notranslate fill-current">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M560-564v-68q33-14 67.5-21t72.5-7q26 0 51 4t49 10v64q-24-9-48.5-13.5T700-600q-38 0-73 9.5T560-564Zm0 220v-68q33-14 67.5-21t72.5-7q26 0 51 4t49 10v64q-24-9-48.5-13.5T700-380q-38 0-73 9t-67 27Zm0-110v-68q33-14 67.5-21t72.5-7q26 0 51 4t49 10v64q-24-9-48.5-13.5T700-490q-38 0-73 9.5T560-454ZM260-320q47 0 91.5 10.5T440-278v-394q-41-24-87-36t-93-12q-36 0-71.5 7T120-692v396q35-12 69.5-18t70.5-6Zm260 42q44-21 88.5-31.5T700-320q36 0 70.5 6t69.5 18v-396q-33-14-68.5-21t-71.5-7q-47 0-93 12t-87 36v394Zm-40 118q-48-38-104-59t-116-21q-42 0-82.5 11T100-198q-21 11-40.5-1T40-234v-482q0-11 5.5-21T62-752q46-24 96-36t102-12q58 0 113.5 15T480-740q51-30 106.5-45T700-800q52 0 102 12t96 36q11 5 16.5 15t5.5 21v482q0 23-19.5 35t-40.5 1q-37-20-77.5-31T700-240q-60 0-116 21t-104 59ZM280-494Z"/></svg>
                                </span>
                                <span>{{ trans.userguide.userguide_ttl }}</span>
                            </a>
                        </li>
                        <li v-if="mapData.attribution_license" @click="$emit('toggled', 'attributionLicense'); toggleDrawer()">
                            <a>
                                <span class="material-symbols-outlined notranslate fill-current">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M400-320h160q17 0 28.5-11.5T600-360v-80h-80v40h-80v-160h80v40h80v-80q0-17-11.5-28.5T560-640H400q-17 0-28.5 11.5T360-600v240q0 17 11.5 28.5T400-320Zm80 240q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                                </span>
                                <span>{{ trans.attribution_license }}</span>
                            </a>
                        </li>
                        <!--
                        <li v-if="parcelTitle">
                            <a :href="displayLink">
                                <span class="material-symbols-outlined pr-0 notranslate fill-current">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"/></svg>
                                </span>
                                <span>{{ trans.right_menu.main_map }}</span>
                            </a>
                        </li>
                        -->
                    </ul>
                </div>
            </div>
            <!-- open switchlanguage button was moved to sidebarnavi--
            <div v-show="showSwitchLanguage" @click="$emit('toggled', 'localeBox')" class="btn btn-sm shadow-sm border border-base-content/5 w-10 h-10 mt-2 side-menu-language">
                <span class="material-symbols-outlined notranslate fill-current">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Zm0-82q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z"/></svg>
                </span>
            </div>
            -->
        </div>
        <!-- left button menu. show new tab -->
        <div class="absolute sm:bottom-0 bottom-16 left-1 z-10 my-1 ml-1 sm:left-24">
            <div v-if="isIframe" v-show="showNewTab" @click="openNewTab()" class="btn btn-sm shadow-sm border border-base-content/5 h-10 mt-2 side-menu-newtab rounded-full px-4">
                <span class="material-symbols-outlined notranslate fill-current">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M120-120v-240h80v104l124-124 56 56-124 124h104v80H120Zm480 0v-80h104L580-324l56-56 124 124v-104h80v240H600ZM324-580 200-704v104h-80v-240h240v80H256l124 124-56 56Zm312 0-56-56 124-124H600v-80h240v240h-80v-104L636-580Z"/></svg>
                </span>
                <span class="normal-case">{{ trans.right_menu.new_tab }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import Fullscreen from './Fullscreen';

export default {
    inject: ['displayLink', 'trans', 'currentMapLink'],
    props: {
        showZoomBtn: {
            type: Boolean,
            required: true
        },
        showFullscreen: {
            type: Boolean,
            required: true
        },
        showRefreshBtn: {
            type: Boolean,
            required: true
        },
        onClickZoom: {
            type: Function,
            required: true
        },
        goToMainMap: {
            type: Function,
            required: true
        },
        showNewTab: {
            type: Boolean,
            required: true
        },
        displayLink: {
            type: String,
            required: true
        },
        trans: {
            type: Object,
            required: true
        },
        showSwitchLanguage: {
            type: Boolean,
            required: true
        },
        mapData: {
            type: Object,
            required: true
        },
        layerTitle: {
            type: String,
            default: ''
        },
        parcelTitle: {
            type: String,
            default: ''
        },
        locales: {
            type: Array,
            default: []
        },
        currentLocale: {
            type: String,
            default: ''
        },
        categoryId: {
            type: Number,
            default: 0
        }
    },
    components: {
        Fullscreen
    },
    methods: {
        openNewTab() {
            window.open(this.displayLink, '_blank');
        },
        toggleDrawer() {
            const drawerToggle = document.querySelector('#my-drawer-4');
            drawerToggle.click();
        },
    },
    computed: {
        isIframe() {
            return window.top !== window.self;
        }
    },
};
</script>

<style>
    .side-menu-z-1000{
        position: relative;
        z-index: 1000;
    }
    .drawer-toggle:checked ~ .drawer-side > .drawer-overlay {
        backdrop-filter: blur(4px);
    }
    .w-ttl{
        width: 18rem;
    }
    .w-txt{
        width: 14rem;
    }
    @media (max-width: 768px) {
    .drawer-side {
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      overflow-y: auto;
      transform: translateX(-100%);
    }

    .drawer-toggle:checked ~ .drawer-side {
      transform: translateX(0);
      overflow-x: hidden;
    }
  }
</style>